module.exports = __webpack_public_path__ + "img/device.6194c1e2.png";